<mat-toolbar color="primary">Patient Details History</mat-toolbar>
<mat-dialog-content class="!p-0">
  @if (loading$ | async) {
    <div
      class="flex flex-col items-center justify-center px-4 py-8 text-black/60"
    >
      <mat-spinner diameter="40" />
      <p class="mt-4 text-sm">Loading history...</p>
    </div>
  } @else if ((historyItems$ | async)?.length) {
    <mat-tree [dataSource]="dataSource" [childrenAccessor]="childrenAccessor">
      <mat-nested-tree-node *matTreeNodeDef="let node">
        <div
          class="flex cursor-pointer items-center gap-2 rounded p-2 hover:bg-slate-50"
          (click)="toggleNode(node)"
        >
          <mat-icon class="mat-icon-rtl-mirror">
            {{ expandedNodes().has(node) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
          <span class="text-sm font-bold">{{ node.name }}</span>
          <span class="text-xs text-slate-500">{{ node.label }}</span>
        </div>
        <div
          class="ml-10 border border-solid border-slate-300"
          [ngClass]="{
            hidden: !expandedNodes().has(node)
          }"
        >
          <json-editor
            [options]="editorOptions"
            [data]="node.serialisedDocument"
          />
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  } @else {
    <div
      class="flex flex-col items-center justify-center px-4 py-8 text-black/[0.38]"
    >
      <mat-icon
        fontSet="material-symbols-outlined"
        class="mb-4 !h-12 !w-12 !text-5xl"
        >folder_open</mat-icon
      >
      <p class="m-0 text-sm">No history records found for this patient.</p>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
